import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import i18next from 'i18next';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialog } from '@angular/material/dialog';
import { StorageService } from '../../core/storage/storage.service';
import { RequestType } from 'src/app/shared/model/requestType.enum';
import { User } from '../../shared/model/user.model';
import { Vehicles } from '../../shared/model/vehicle.model';
import { OrderRequest } from 'src/app/shared/model/order.model';
import { StepperComponent } from 'src/app/shared/components/stepper/stepper.component';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';
import { OrderService } from 'src/app/core/services/order.service';
import { UtilsService } from 'src/app/core/services/utils.service';
import { ModalConfirmRequestComponent } from 'src/app/shared/components/modal-confirm-request/modal-confirm-request.component';

@Component({
  standalone: true,
  selector: 'app-vo-request',
  templateUrl: './vo-request.component.html',
  styleUrls: ['./vo-request.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    RouterModule,
    MatFormFieldModule,
    StepperComponent
  ]
})
export class VoRequestComponent implements OnInit {
  @ViewChild('stepperHeader') stepperHeader!: ElementRef;

  user!: User;
  requestType = RequestType.vo;
  newRequest!: OrderRequest;
  orderType = '';
  spinner = false;
  data = '';
  ad?: boolean;
  stockVehicle?: Vehicles;

  //Stepper
  isLinear = true;

  steps = new Map<string, boolean>();

  landing2 = false;
  requestCarType = null;
  isVip = false;
  loading = false;
  isPhone = false;

  constructor(
    private storageService: StorageService,
    private orderService: OrderService,
    public dialog: MatDialog,
    private router: Router,
    private utilsService: UtilsService
  ) {}

  ngOnInit(): void {
    this.isPhone = this.utilsService.isPhone();
    this.landing2 = this.storageService.get('landing2') || false;
    this.requestCarType = this.storageService.get('requestCarType') || null;
    this.storageService.set('navigation', 'newRequest');
    this.user = this.storageService.get('config');
    if (this.storageService.get('ad')) {
      this.ad = this.storageService.get('ad');
    }
    if (this.ad === true) {
      this.router.navigateByUrl('/landing');
    }

    this.setSteps();
    setTimeout(() => {
      this.adjustStepper();
    }, 100);
  }

  @HostListener('window:resize')
  onResize() {
    this.adjustStepper();
  }

  private openLegalModal() {
    return this.dialog.open(ModalConfirmRequestComponent, {
      disableClose: true,
      data: {
        htmlKey: 'voLegalModalHtml',
        confirmText: 'buttonConfirm',
        cancelText: 'btnCancel'
      }
    });
  }

  private openVoConfirmModal() {
    return this.dialog.open(ModalConfirmRequestComponent, {
      disableClose: true,
      data: {
        titleKey: 'confirmReservationTitle',
        textKey: 'confirmVoReservationText',
        confirmText: 'buttonConfirm',
        cancelText: 'btnCancel'
      }
    });
  }

  sendRequest(newRequestData: any) {
    this.openLegalModal()
      .afterClosed()
      .subscribe((legalAccepted) => {
        if (!legalAccepted) return;

        this.openVoConfirmModal()
          .afterClosed()
          .subscribe((confirmed) => {
            if (!confirmed) return;

            this.loading = true;

            this.orderService.createVo(newRequestData).subscribe({
              next: () => {
                this.loading = false;

                const isSecondBooking =
                  newRequestData.vehicles.vehicleGroups.bookingsVo === 1;

                const dialogRef = this.dialog.open(FeedbackModalComponent, {
                  data: {
                    text: isSecondBooking
                      ? i18next.t('voBookingSecondOk')
                      : i18next.t('voBookingFirstOk'),
                    close: true,
                    theme: 'ligth'
                  }
                });

                dialogRef.afterClosed().subscribe(() => {
                  this.router
                    .navigateByUrl('/', { skipLocationChange: true })
                    .then(() => {
                      this.router.navigate(['/vo']);
                    });
                });
              },
              error: () => {
                this.loading = false;
                this.dialog.open(FeedbackModalComponent, {
                  data: {
                    text: i18next.t('newRequestKO'),
                    close: true,
                    theme: 'ligth'
                  },
                  disableClose: true
                });
              }
            });
          });
      });
  }

  // sendRequest(newRequestData: any) {
  //   const dialogRef = this.dialog.open(ModalConfirmRequestComponent);
  //   dialogRef.componentInstance.submitRequestEmitter.subscribe(() => {
  //     this.loading = true;
  //     this.orderService.createVo(newRequestData).subscribe({
  //       next: () => {
  //         this.loading = false;
  //         this.dialog.open(FeedbackModalComponent, {
  //           data: {
  //             text: i18next.t('bookingVehicleOk'),
  //             redirect: true,
  //             list: true,
  //             theme: 'ligth'
  //           },
  //           disableClose: true
  //         });
  //       },
  //       error: () => {
  //         this.loading = false;
  //         this.dialog.open(FeedbackModalComponent, {
  //           data: {
  //             text: i18next.t('newRequestKO'),
  //             close: true,
  //             theme: 'ligth'
  //           },
  //           disableClose: true
  //         });
  //       }
  //     });
  //   });
  // }

  setSteps() {
    this.steps.set('approvers', false);
    this.steps.set('request-info', false);
    this.steps.set('stockVehicle', true);
    this.steps.set('car-config', false);
    this.steps.set('additionalInfo', false);
    this.steps.set('resume', false);
  }

  adjustStepper() {
    const stepperHeaderContainer: any = document.querySelector(
      '.mat-horizontal-stepper-header-container'
    );
    if (stepperHeaderContainer) {
      //scale 0.8
      stepperHeaderContainer.style.transform = 'scale(0.8)';
      stepperHeaderContainer.style.transformOrigin = 'center right';

      const offY = stepperHeaderContainer.offsetHeight / 2;

      const stepperHeader = this.stepperHeader.nativeElement;
      const x = stepperHeader.getBoundingClientRect().x;

      const right = window.innerWidth - x;
      stepperHeaderContainer.style.position = 'absolute';
      stepperHeaderContainer.style.top = stepperHeader.offsetTop - offY + 'px';
      stepperHeaderContainer.style.right = right + 'px';
    }
    if (stepperHeaderContainer && window.innerWidth <= 1024) {
      stepperHeaderContainer.style.transformOrigin = 'center left';
      stepperHeaderContainer.style['flex-wrap'] = 'wrap';
      stepperHeaderContainer.style.position = 'unset';
    }
  }

  goHome() {
    this.router.navigateByUrl('/landing-leasing');
  }
}
